import { createContext } from 'react';
const Ctx = createContext();
export default Ctx;
